import React from 'react';
import { ComingSoon } from './pages/ComingSoon';
interface AppProps {
  /** Ambient field behind the page. */
  backdrop?: 'shimmer' | 'embers' | 'none';
  /** Daylight kitchen or evening service. */
  palette?: 'warm' | 'night';
}
export function App({
  backdrop = 'shimmer',
  palette = 'warm'
}: AppProps) {
  return <ComingSoon backdrop={backdrop} palette={palette} data-id="element-0" data-mp="3fbjcb6vrpzx0" />;
}